<div class="change-password mt-3">
  <div class="mb-3">To change your password, please click the button below to receive an email with instructions on how to reset your password.</div>
  <button class="upsc-primary-button icon-right" (click)="auth0ResetPassword()" *ngIf="!loading">
    {{ 'profile.profileMenus.updatePassword' | translate }}<mat-icon>chevron_right</mat-icon>
  </button>
  <button class="upsc-primary-button icon-right" disabled *ngIf="loading">
    {{ 'profile.profileMenus.updatePassword' | translate }}<span class="spinner-border"></span>
  </button>

  <div class="change-password bold mt-3" *ngIf="successMessage">
    <div class="mb-3">An email has been sent to reset your password.</div>
  </div>

  <div class="error" *ngIf="systemError">
    {{ 'common.systemError' | translate }}
  </div>
</div>